import React, { useCallback } from "react";
import * as yup from "yup";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Form } from "react-final-form";
import Validator from "../../../../_helpers/validate.schema";
import { UiCol } from "../../../_uiComponents/grid-container/GridContainer";
import { UiInput, UiInputLink } from "../../../_uiComponents/form/UiInput";
import { getFingerPrint } from "../../../../_helpers/support.services";
import { UiButton, UiButtonPrimary } from "../../../_uiComponents/form/UiButton";
import { loginAuthRequest } from "../../../../_redux/_actions";
import UiInlineSuccessMessage from "../../../_uiComponents/form/UiInlineSuccessMessage"

const validateSchema = () =>
    yup.object().shape({
        otpVerify: yup.string().required("OTP Verify is required."),
    });

const onValidate = async (values) => {
    return await Validator(values, validateSchema);
};

export default function ChangePasswordOtpVerification(props) {

    const submit = async (values) => {
        props.handleOtpVerify(values)
    };

    return (
        <Form
            onSubmit={submit}
            validate={onValidate}
            render={({ handleSubmit, hasValidationErrors }) => (
                <form onSubmit={validateSchema}>
                    <UiCol lg="12">
                        <div className="sb-prof-password-otp">
                            <h5>Please enter the OTP sent to your registered mobile & email</h5>
                            <UiInput type="number" name="otpVerify" placeholder="Enter the OTP" />
                            <span>Resend OTP</span>
                        </div>
                    </UiCol>

                    <UiCol lg="12">
                        <div className="sb-prof-otp-verify">
                            <UiButtonPrimary
                                btnName={"Verify"}
                                onClick={handleSubmit}
                            />
                        </div>
                    </UiCol>
                </form>
            )}
        />
    );
}
